import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
// history.listen((location) => {
//     console.log('location', location);
// });

export default history;
